import { DeviceCheckResult, DeviceCheckStage } from '~/generated/graphql';

declare global {
  interface Screen {
    isExtended?: boolean;
  }

  interface BatteryManager {
    charging: boolean;
    level: number;
  }

  interface Navigator {
    getBattery?(): Promise<BatteryManager>;
  }
}

export interface AppContextStateType {
  deviceId: string;
  deviceIdIsLoading: boolean;
  examineePhotoIsLoading: boolean;
  examineePhotoSrc: string;
  extensionVersion?: string;
  isKioskMode?: boolean;
  operatingSystem?: string;
  testCenterDrawerIsOpen: boolean;
  testCenterId?: string;
  registrationId?: string;
  user?: string;
  registrationDetails: string;
}

export enum BuildEnv {
  Local = 'local',
  Feature = 'feature',
  Development = 'development',
  Staging = 'staging',
  Production = 'production',
}

export interface DebugContextStateType {
  todayDateSimulated?: string;
}

export interface ITokenObj {
  accessToken: string;
  exp: number;
}

export interface DeviceCheckResults {
  expectedValue?: string;
  result: DeviceCheckResult;
  value?: string;
  apps?: string[];
}

export interface DeviceCheckMetadata {
  check: (args: {
    expectedValue?: string;
    urls?: string[];
    registrationDetails?: string;
  }) => Promise<DeviceCheckResults> | DeviceCheckResults;
  failure: (args: { expectedValue?: string }) => {
    description: string;
    imgSrc: string;
    title: string;
  };
}

export interface CheckStageRequirement {
  checkStage: DeviceCheckStage;
  expectedValue?: string;
  urls?: string[];
  registrationDetails?: string;
}

export interface CheckStageResult {
  checkStage: DeviceCheckStage;
  expectedValue?: string;
  result: DeviceCheckResult;
  value?: string;
  apps?: string[];
}

export interface DeviceCheckContextStateType {
  checkResults: CheckStageResult[];
  checksToRun: CheckStageRequirement[];
  currentIndex: number;
  isRunning: boolean;
  percentProgress: number;
  hasError: boolean | undefined;
  calculatorEndpoint?: string | null;
}

export interface ILogger {
  name?: string;
  error(...args: unknown[]): void;
  log(...args: unknown[]): void;
  warn(...args: unknown[]): void;
  trace(...args: unknown[]): void;
  debug(...args: unknown[]): void;
}

export type ModuleName = 'English' | 'Math' | 'Reading' | 'Science' | 'Writing';

export enum ProgramName {
  National = 'NATIONAL',
  Special = 'SPECIAL',
}

export enum TestLaunchStep {
  ConfirmInfo = 'Confirm Info',
  DeviceCheck = 'Device Check',
  EOS = 'Educational Opportunity Service',
  ExamineeStatements = 'Examinee Statements',
  LaunchTest = 'Launch Test',
}

export interface Option {
  description?: string;
  disabled?: boolean;
  label: string;
  secondaryAction?: React.ReactElement;
  value: string | number;
}

export interface Electron {
  invoke: (channel: string, ...args: unknown[]) => Promise<unknown>;
  receive: (channel: string, func: (message: string) => void) => void;
  send: (channel: string, message: string) => void;
}
